import { useReducer } from 'react';

type Result = {
    forceRender: () => unknown;
};

export function useForceRender(): Result {
	const [, forceRender] = useReducer((x) => x + 1, 0);
	return { forceRender };
}